<template>
  <div class="cost_application">
    <div class="top">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>已发费用通知的申请</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <div class="search">
        <div class="search_son">
          <!-- <span class="input">申请编号</span> -->
          <el-input
            size="mini"
            placeholder="请输入项目编号/缴费单位"
            clearable
            v-model="form.number"
          ></el-input>
        </div>
        <!-- <div class="search_son">
          <span class="input">委托单位</span>
          <el-input
            size="mini"
            placeholder="请输入委托单位"
            clearable
            v-model="form.company"
          ></el-input>
        </div> -->
        <!-- <div class="search_son">
          <span class="select">财务处理</span>
          <el-select size="mini" placeholder="请选择" v-model="form.finance">
            <el-option
              v-for="item in finances"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="search_son">
          <span class="select">汇款信息</span>
          <el-select size="mini" placeholder="请选择" v-model="form.remittance">
            <el-option
              v-for="item in remittances"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="search_son time">
          <span class="select">通知时间</span>
          <el-date-picker
            size="mini"
            v-model="form.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div> -->
        <div class="search_son btn">
          <el-button type="primary" round size="mini" @click="search"
            >查询</el-button
          >
        </div>
        <div class="search_son refresh" @click="refresh">
          <i class="el-icon-refresh"></i>刷新-共{{ total }}条数据
        </div>
      </div>
      <!-- <div class="search_btn">
        <el-button type="primary" size="mini" @click="fillRemittance">填写汇款信息</el-button>
        <el-button type="primary" size="mini" icon="el-icon-bottom"
          >导出Excel</el-button
        >
      </div> -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        highlight-current-row
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- <el-table-column type="selection" width="55" align="center">
        </el-table-column> -->
        <el-table-column type="index" width="50" label="序号" align="center">
        </el-table-column>
        <!-- <el-table-column label="申请编号" align="center">
          <template slot-scope="scope">{{ scope.row.project_number }}</template>
        </el-table-column> -->
        <el-table-column label="项目编号" align="center">
          <template slot-scope="scope">{{ scope.row.project_number }}</template>
        </el-table-column>
        <el-table-column label="委托单位" align="center">
          <template slot-scope="scope">{{
            scope.row.enterprise_client_name
          }}</template>
        </el-table-column>
        <el-table-column label="缴费单位" align="center">
          <template slot-scope="scope">{{ scope.row.pay_company }}</template>
        </el-table-column>
        <el-table-column label="产品名称" align="center">
          <template slot-scope="scope">{{ scope.row.product_name }}</template>
        </el-table-column>
        <el-table-column label="项目金额（包含6%增值税）" align="center">
          <template slot-scope="scope">{{ scope.row.project_money }}</template>
        </el-table-column>
        <el-table-column label="已缴费" align="center">
          <template slot-scope="scope">{{ scope.row.pay_money }}</template>
        </el-table-column>
        <el-table-column label="未缴费" align="center">
          <template slot-scope="scope">{{
            scope.row.surplus_balance
          }}</template>
        </el-table-column>
        <el-table-column label="收费通知时间" align="center">
          <template slot-scope="scope">{{ scope.row.ctime }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.status_name }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center"
          ><template slot-scope="scope">
            <span class="look" @click="fillRemittance(scope.row)"
              >填写汇款信息</span
            ></template
          >
        </el-table-column>
      </el-table>
      <div class="page_footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="npage"
          :page-size="pagesize"
          layout="total, prev, pager, next,jumper"
          background
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "../../filters/filters.js";
import { httpFinanceList } from "../../utils/myexpends";
export default {
  data() {
    return {
      npage: 1, //当前页
      pagesize: 10, //每页显示条数
      total: 0, //总条数
      form: {
        number: "",
        company: "",
        finance: "",
        remittance: "",
        time: "",
      },
      finances: [
        { label: "财务未操作", value: "1" },
        { label: "费用交齐", value: "2" },
        { label: "需要交款", value: "3" },
        { label: "需退款", value: "4" },
        { label: "已收到交款回执，暂缓结算", value: "5" },
        { label: "暂缓交款", value: "6" },
        { label: "交付中止", value: "7" },
      ],
      remittances: [
        { label: "已填写汇款", value: "1" },
        { label: "未填写汇款", value: "2" },
      ],
      tableData: [],
    };
  },
  methods: {
    //查询
    search() {
      this._httpFinanceList(1, this.pagesize, this.form.number);
    },
    //分页
    handleSizeChange(val) {
      this.pagesize = val;
      this._httpFinanceList(this.npage, this.pagesize, this.form.number);
    },
    handleCurrentChange(val) {
      this.npage = val;
      this._httpFinanceList(this.npage, this.pagesize, this.form.number);
    },
    //刷新
    refresh() {
      this.form.number = "";
      this._httpFinanceList(1, this.pagesize, this.form.number);
    },
    //已发费用列表
    _httpFinanceList(page, limit, keyword) {
      httpFinanceList(page, limit, keyword).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.total = data.data.total_records;
          this.tableData = data.data.list;
        } else {
          this.$message(data.msg);
        }
      });
    },
    //填写汇款信息
    fillRemittance({ id }) {
      this.$router.push({ path: "/fillRemittance", query: { id: id } });
    },
  },
  filters: {
    formatDate(time) {
      var data = new Date(time * 1000);
      return formatDate(data, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {
    this._httpFinanceList(this.npage, this.pagesize);
  },
};
</script>

<style lang="scss" scoped>
.cost_application {
  .top {
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;
  }
  .main {
    .search {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      .search_son {
        display: flex;
        margin-right: 10px;
        width: 200px;
        margin-bottom: 5px;
        .input,
        .select {
          display: inline-block;
          height: 28px;
          line-height: 28px;
          width: 100px;
        }
        &.time {
          width: 300px;
        }
        &.btn {
          width: 56px;
        }
        i {
          font-size: 24px;
          line-height: 30px;
          cursor: pointer;
        }
        &.refresh {
          line-height: 30px;
        }
      }
    }
    .search_btn {
      margin: 10px 0;
    }
    .look {
      color: #62b3ff;
      cursor: pointer;
    }
    .page_footer {
      display: flex;
      justify-content: flex-end;
      margin: 20px;
    }
    /deep/ .el-table th {
      background-color: #f2f6fc !important;
    }
  }
}
</style>